import { render } from "./AppSidebar.vue?vue&type=template&id=b8bdc994"
import script from "./AppSidebar.vue?vue&type=script&lang=js"
export * from "./AppSidebar.vue?vue&type=script&lang=js"

import "./AppSidebar.vue?vue&type=style&index=0&id=b8bdc994&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__